<template>
  <router-link :to="{name: 'recipeView', params: { id: recipe.id }}">
    <b-card no-body
      :img-src="recipe.bannerUrl"
      img-alt="Image"
      img-top
      tag="div"
      style="max-width: 20rem; min-height: 20rem"
      class="recipe-card card-img-top"
    >
    <b-card-body>
      <b-card-title>
        <router-link :title="recipe.title" class="text-dark card-text" :to="{ name: 'recipeView', params: { id: recipe.id }}" v-b-tooltip.hover.bottom>
          {{ recipe.title | truncate(55, '...') }}
        </router-link>
      </b-card-title>
    </b-card-body>
    </b-card>
  </router-link>
</template>

<script>
export default {
  name: 'featuredRecipeCard',
  props: {
    'recipe': Object
  }
}
</script>

<style scoped>
.recipe-card {
  height: 260px;
}
.card-img-top {
width: 100%;
height: 180px;
object-fit: cover;
}
.card-text {
    font-size: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/recipes/FeaturedRecipeCard.vue